import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './NotificationBadge.css';
import NotificationCenter from './NotificationCenter';
import api from '../services/api';

const NotificationBadge = () => {
  const [contador, setContador] = useState(0);
  const [showCenter, setShowCenter] = useState(false);

  useEffect(() => {
    cargarContador();
    
    // Actualizar cada 30 segundos
    const interval = setInterval(cargarContador, 30000);
    
    return () => clearInterval(interval);
  }, []);

  const cargarContador = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;

      const response = await api.get('/notificaciones/contador');

      if (response.data.success) {
        setContador(response.data.contador);
      }
    } catch (error) {
      // Silencioso - no mostrar error si falla
      console.log('Error cargando contador notificaciones:', error.message);
    }
  };

  const handleClick = () => {
    setShowCenter(!showCenter);
  };

  const handleClose = () => {
    setShowCenter(false);
    // Recargar contador al cerrar
    cargarContador();
  };

  return (
    <>
      <div className="notification-badge-wrapper" onClick={handleClick}>
        <span className="notification-bell">🔔</span>
        {contador > 0 && (
          <span className="notification-counter">{contador > 99 ? '99+' : contador}</span>
        )}
      </div>
      
      <NotificationCenter 
        isOpen={showCenter} 
        onClose={handleClose}
      />
    </>
  );
};

export default NotificationBadge;

